import { useCallback, useEffect, useState } from 'react';
import { GoogleMap, HeatmapLayerF } from '@react-google-maps/api';
import { Location } from 'types';
import { getLocationsHeatMapValue } from 'utils/map';

type HeatMapProps = {
  mapCenter: { lat: number; lng: number };
  mapZoom: number;
  locations: Location[];
  heatMapFilter: string;
};

export default function HeatMap({
  mapCenter,
  mapZoom,
  locations,
  heatMapFilter
}: HeatMapProps) {
  const [mapInstance, setMapInstance] = useState<any>();

  const getHeatMapWeight = useCallback(
    (heatMapFilter: string) =>
      getLocationsHeatMapValue(locations, heatMapFilter),
    [locations]
  );

  useEffect(() => {
    if (mapInstance && heatMapFilter) {
      const heatmapData = locations
        .map((location, i) => {
          const weight = getHeatMapWeight(heatMapFilter)[i];

          if (weight) {
            return {
              location: new google.maps.LatLng(
                location.latitude,
                location.longitude
              ),
              weight
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      mapInstance.setData(heatmapData);
    }
  }, [mapInstance, heatMapFilter, locations, getHeatMapWeight]);

  return (
    <div className="absolute top-0 right-0 bottom-0 left-0 hidden sm:block h-full w-full">
      <GoogleMap
        mapContainerClassName="map-container"
        center={mapCenter}
        zoom={mapZoom}
        options={{
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          zoomControlOptions: {
            position: 3
          }
        }}
        id="act-dashboard-google-map-heat"
      >
        <HeatmapLayerF
          data={[]}
          options={{
            radius: 50
          }}
          onLoad={(map) => setMapInstance(map)}
        />
      </GoogleMap>
    </div>
  );
}
